export const GENERAL_ADMISSION = 'GENERAL_ADMISSION';
export const GENERAL_ADMISSION_REF = "GENERAL_ADMISSION_REF"
export const FONT_COLOR_HEX = '#ffffff';
export const HEADER_BG_COLOR_HEX = '#0050a7';
export const FIELDS_BG_COLOR_HEX = '#016cde';